// Only destinations mounted by App.tsx can be carried through sign-in.
export const websiteApplicationRoutes = ['/', '/code', '/swarm', '/explore'] as const;

export function websiteSignInDestination(search: string): string {
  const next = new URLSearchParams(search).get('next');
  return websiteApplicationRoutes.find(route => route === next) ?? '/';
}
